// extracted by mini-css-extract-plugin
export default {"row":"HNSOu","value":"q5bNY"};